<template>
  <el-dialog
    width="80%"
    :visible.sync="showCommodity"
    :before-close="closeCommodity"
    :append-to-body="true"
  >
    <el-row :gutter="20" class="searchRow" type="flex" align="middle">
      <el-col :span="4">
        <el-input v-model="queryform.name" clearable placeholder="商品名称"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="handleButton(1)">搜 索</el-button>
        <el-button type="primary" @click="handleButton(2)">重 置</el-button>
      </el-col>
      <el-col :span="4">
        <p>已选择{{multipleSelection.length}}件商品</p>
      </el-col>
    </el-row>
    <el-table
      ref="multipleTable"
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :header-cell-style="headClass"
      :cell-style="rowClass"
      :row-key="getRowKey"
      v-loading="loading"
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="selection" width="55" reserve-selection :selectable="selectHandle" />
      <el-table-column prop="spu_id" label="商品ID" />
      <el-table-column label="商品图片">
        <template slot-scope="scope">
          <img class="imge" :src="scope.row.image_main" alt />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="商品名称" />
      <el-table-column prop="sta_name" label="商品分类" />
      <el-table-column prop="total_stock" label="库存" />
      <el-table-column prop="sku_price_sell" label="销售价" />
      <el-table-column label="是否参加活动">
        <template slot-scope="scope">
          <div v-if="scope.row.activity_flg == 0">未参加</div>
          <div v-if="scope.row.activity_flg == 1">参加</div>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" class="row-bg" justify="end">
      <el-col :span="4">
        <el-button type="primary" class="but" @click="save">保存</el-button>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <pagination
      v-if="list.length>0"
      :total="total"
      :pageNum="queryform.page"
      :pageSize="queryform.pageSize"
      @pageChange="pageChange"
    />
  </el-dialog>
</template>

<script>
import pagination from "@/components/pagination/index.vue";
import { couponsList } from "@/api/couponManagement/couponSetting";
export default {
  props: ["show", "stores", "commoditys"],
  components: {
    pagination,
  },
  data() {
    return {
      loading: true,
      showCommodity: false,
      form: {
        name: "",
      },
      queryform: {
        name: "",
        pageSize: 10,
        page: 1,
      },
      total: 0,
      list: [],
      multipleSelection: [],
    };
  },
  watch: {
    show(value) {
      Object.assign(this.$data, this.$options.data()); //重置data
      this.showCommodity = this.show;
      if (value) {
        this.getcouponsList();
      }
    },
  },
  methods: {
    selectHandle(row, index) {
      return !(row.activity_flg == 1);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.activity_flg == 1) {
        return "warning-row";
      }
      return "";
    },
    getRowKey(row) {
      return row.spu_id;
    },
    rowClass() {
      return "text-align:center";
    }, //表格数据居中显示
    headClass() {
      return "text-align:center";
    }, //表头居中显示
    closeCommodity() {
      if (this.multipleSelection.length != 0 && this.stores != 60) {
        this.$confirm("优惠券不可跨店铺绑定，返回后将清除之前的选择操作，是否继续返回", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            this.$emit("close");
          })
          .catch(() => {
            this.$message({
              message: "已取消",
            });
          });
      } else {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          this.$store.multipleSelection.push(this.multipleSelection[i]);
        }
        this.$emit("close");
      }
    },
    pageChange(page) {
      this.queryform.pageSize = page._pageSize;
      this.queryform.page = page._currentPage;
      this.getcouponsList();
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    handleButton(val) {
      switch (val) {
        case 1:
          this.getcouponsList();
          break;
        case 2:
          this.queryform.name = "";
          this.queryform.shop_id = "";
          this.getcouponsList();
          break;
        default:
          break;
      }
    },
    save() {
      this.$store.goodsList = this.multipleSelection;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.$store.multipleSelection.push(this.multipleSelection[i]);
      }
      this.$emit("close", 1);
    },
    getcouponsList() {
      this.$store.commoditys = this.commoditys;
      let data = {
        token: this.$getSessionStorage("token"),
        page: this.queryform.page,
        size: this.queryform.pageSize,
        shop_id: this.commoditys,
        name: this.queryform.name,
        status: 1,
      };
      couponsList(data).then((res) => {
        if (res.code == 1) {
          this.list = res.data.list;
          this.total = parseInt(res.data.count);
          this.loading = false;
          console.log(this.list, "res----------------------");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.but {
  margin-top: 20px;
}
.imge {
  width: 60px;
  height: 60px;
}
</style>
<style>
.el-table .warning-row {
  background: rgb(225, 225, 225);
}
</style>